// src/ThemeToggle.js
import React from "react";
import { useTranslation } from "react-i18next";

const ThemeToggle = ({ isDarkMode, onToggle }) => {
  const { t } = useTranslation();
  return (
    <button className="theme-toggle" onClick={onToggle} aria-label={t("toggleTheme")}>
      {isDarkMode ? (
        // Moon with stars
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Stars */}
          <circle cx="8" cy="6" r="1" fill="white" opacity="0.9" />
          <circle cx="24" cy="8" r="0.8" fill="white" opacity="0.8" />
          <circle cx="6" cy="12" r="0.7" fill="white" opacity="0.7" />
          <circle cx="26" cy="14" r="0.9" fill="white" opacity="0.85" />
          <circle cx="10" cy="20" r="0.6" fill="white" opacity="0.75" />
          <circle cx="22" cy="22" r="0.8" fill="white" opacity="0.8" />
          {/* Moon */}
          <path
            d="M16 8C16 12.4183 12.4183 16 8 16C8 20.4183 11.5817 24 16 24C20.4183 24 24 20.4183 24 16C20.4183 16 16 12.4183 16 8Z"
            fill="#f9b31c"
          />
        </svg>
      ) : (
        // Sun with blue sky
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Sun rays */}
          <line x1="16" y1="2" x2="16" y2="6" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="16" y1="26" x2="16" y2="30" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="2" y1="16" x2="6" y2="16" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="26" y1="16" x2="30" y2="16" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="6.343" y1="6.343" x2="8.929" y2="8.929" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="23.071" y1="23.071" x2="25.657" y2="25.657" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="6.343" y1="25.657" x2="8.929" y2="23.071" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="23.071" y1="8.929" x2="25.657" y2="6.343" stroke="#fc9a13" strokeWidth="1.5" strokeLinecap="round" />
          {/* Sun circle */}
          <circle cx="16" cy="16" r="6" fill="#f9b31c" />
        </svg>
      )}
    </button>
  );
};

export default ThemeToggle;
